import { NavBar } from "antd-mobile"
import { useCallback, useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { findById } from "../../api/getNews"

function Header() {
  const navigate = useNavigate()
  const [title, setTitle] = useState("")
  const location = useLocation()
  const { pathname, search } = location

  useEffect(() => {
    if (search) {
      const id = search.slice(1)
      setTitle(findById(Number(id)).name || "")
    } else {
      switch (pathname) {
        case "/drank": {
          setTitle("Потребление воды")
          break
        }

        case "/ate": {
          setTitle("Потребление калорий")
          break
        }

        case "/myDiet": {
          setTitle("Мой рацион")
          break
        }

        case "/addNewProduct": {
          setTitle("Добавить новый продукт")
          break
        }

        case "/statistic": {
          setTitle("Статистика")
          break
        }

        default:
          setTitle("")
      }
    }
  }, [pathname, search])

  const onBack = useCallback(() => {
    if (pathname === "/recipeDetails") {
      navigate("/news")
    }
    if (["/statistic", "/myDiet", "/drank", "/ate"].includes(pathname)) {
      navigate("/traker")
    }

    if (["/addNewProduct"].includes(pathname)) {
      navigate("/ate")
    }
  }, [navigate, pathname])

  if (
    ![
      "/recipeDetails",
      "/statistic",
      "/myDiet",
      "/addNewProduct",
      "/ate",
      "/drank",
    ].includes(pathname)
  ) {
    return null
  }

  return (
    <NavBar back="" onBack={onBack} style={{ background: '#86D27B', color: 'white'}}>
      {title}
    </NavBar>
  )
}

export default Header
